const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_benefits/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_benefits/LIST_COMPANY_BENEFITS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.company_benefits/LIST_COMPANY_BENEFITS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    default:
      return state;
  }
}
